/** URL: `?menu_debug=1` oder `?menu_debug=true` — Menü beim Laden geöffnet (nur für lokales Styling/Debug). */
var menuDebugOpenFromUrl = function () {
    var value = new URLSearchParams(window.location.search).get('menu_debug');
    return value === '1' || value === 'true';
};
/** Apple-Plattformen (⌘); sonst Strg (Windows, Linux, …) */
var prefersMacOsShortcutUi = function () {
    var _a, _b;
    var platform = (_a = navigator.platform) !== null && _a !== void 0 ? _a : '';
    var ua = (_b = navigator.userAgent) !== null && _b !== void 0 ? _b : '';
    return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS/i.test(ua);
};
var setMenuToggleAriaLabelForPlatform = function (toggle) {
    var mac = toggle.dataset.shortcutAriaMacos;
    var other = toggle.dataset.shortcutAriaOther;
    if (!(mac === null || mac === void 0 ? void 0 : mac.trim()) || !(other === null || other === void 0 ? void 0 : other.trim())) {
        return;
    }
    toggle.setAttribute('aria-label', prefersMacOsShortcutUi() ? mac : other);
};
var isTypingField = function (el) {
    if (!el || !(el instanceof HTMLElement)) {
        return false;
    }
    var tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
        return true;
    }
    if (el.isContentEditable) {
        return true;
    }
    return el.closest('[contenteditable="true"]') !== null;
};
var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
var isVisibleForFocus = function (el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }
    if (el.getAttribute('aria-hidden') === 'true') {
        return false;
    }
    return true;
};
var getNavFocusables = function (nav) {
    return Array.from(nav.querySelectorAll(focusableSelector)).filter(isVisibleForFocus);
};
var initMenuToggle = function () {
    var _a;
    var toggle = document.querySelector('.menu-toggle');
    var nav = document.querySelector('#primary-navigation');
    var header = (_a = toggle === null || toggle === void 0 ? void 0 : toggle.closest('header')) !== null && _a !== void 0 ? _a : null;
    if (!toggle || !nav || !header) {
        return;
    }
    setMenuToggleAriaLabelForPlatform(toggle);
    var isOpen = function () { return header.classList.contains('open'); };
    var setOpen = function (open) {
        header.classList.toggle('open', open);
        nav.classList.toggle('open', open);
        nav.inert = !open;
        toggle.setAttribute('aria-expanded', String(open));
    };
    var focusFirstMenuItem = function () {
        queueMicrotask(function () {
            var items = getNavFocusables(nav);
            var first = items[0];
            if (!first) {
                return;
            }
            // Kein :focus-visible-Styling beim automatischen Öffnen — Vorschaubild bleibt „neutral“ bis Nutzerinteraktion.
            first.focus({
                preventScroll: true,
                focusVisible: false,
            });
        });
    };
    if (menuDebugOpenFromUrl()) {
        setOpen(true);
        focusFirstMenuItem();
    }
    else {
        nav.inert = true;
    }
    toggle.addEventListener('click', function () {
        var next = !isOpen();
        setOpen(next);
        if (next) {
            focusFirstMenuItem();
        }
    });
    document.addEventListener('click', function (event) {
        if (!isOpen()) {
            return;
        }
        var target = event.target;
        if (header.contains(target) || nav.contains(target)) {
            return;
        }
        setOpen(false);
    });
    document.addEventListener('focusin', function (event) {
        if (!isOpen()) {
            return;
        }
        var target = event.target;
        if (!(target instanceof Node)) {
            return;
        }
        if (nav.contains(target) || toggle.contains(target)) {
            return;
        }
        setOpen(false);
    }, true);
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
            event.preventDefault();
            setOpen(false);
            toggle.focus();
            return;
        }
        if (!(event.metaKey || event.ctrlKey) || event.altKey) {
            return;
        }
        if (event.key !== 'k' && event.key !== 'K') {
            return;
        }
        if (isTypingField(event.target)) {
            return;
        }
        event.preventDefault();
        if (isOpen()) {
            setOpen(false);
            toggle.focus();
        }
        else {
            setOpen(true);
            focusFirstMenuItem();
        }
    }, true);
    nav.addEventListener('keydown', function (event) {
        var _a;
        if (!isOpen()) {
            return;
        }
        var delta = 0;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            delta = 1;
        }
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            delta = -1;
        }
        else {
            return;
        }
        var items = getNavFocusables(nav);
        if (items.length === 0) {
            return;
        }
        event.preventDefault();
        var active = document.activeElement;
        var idx = active instanceof HTMLElement ? items.indexOf(active) : -1;
        if (idx === -1) {
            idx = 0;
        }
        else {
            idx = (idx + delta + items.length) % items.length;
        }
        (_a = items[idx]) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
    });
};
export default initMenuToggle;
